import React from 'react';
import AddButton from '../../../../common/controls/AddButton';

import AddRow from '../../../../common/controls/AddRow';

const IssueBar: React.FC<any> = (props: any) => {
  const { handleOpenIssuePicker, isReadOnlyMode } = props;

  return (
    <AddRow
      label='Issues'
      buttons={
        <AddButton
          disabled={isReadOnlyMode}
          label='ATTACH ISSUE'
          onClick={handleOpenIssuePicker}
        />
      }
    />
  );
};

export default IssueBar;
